<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择采购订单"
      width="1200px">
    <el-table
        :data="tableData">
      <el-table-column
          prop="materialNo"
          align="center"
          label="物料编号"
          show-overflow-tooltip
          width="120"/>
      <el-table-column
          prop="purchaseOrderNo"
          align="center"
          label="采购订单号"/>
      <el-table-column
          prop="purchaseQuantity"
          align="center"
          label="采购订单数量"/>
      <el-table-column
          prop="hasInStorageQty"
          align="center"
          label="已入库数量"/>
      <el-table-column
          prop=""
          align="center"
          label="可用数量">
        <template v-slot="scope">
          <span>{{scope.row.purchaseQuantity - scope.row.hasInStorageQty}}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="poDetailRowNo"
          align="center"
          label="采购订单行号"/>
      <el-table-column
          prop="roundedValue"
          align="left"
          label="舍入值"/>
      <el-table-column
          prop="supplierName"
          align="left"
          label="供应商"/>
      <el-table-column
          prop="supplierCode"
          align="left"
          label="供应商编号"/>
      <el-table-column
          label="操作"
          fixed="right"
          align="center"
          class-name="vm-table_operate"
          width="120">
        <template v-slot="scope">
          <el-button :disabled="scope.row.isDisabled" type="primary" @click="selectRow(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>

  export default {
    name: "PurchasePlanSelect",
    components: {},
    data() {
      return {
        dialogVisible: false,
        tableData: [],
        index: 0,
        filter: {},
      };
    },
    methods: {
      open(row, index) {
        this.dialogVisible = true;
        this.tableData = [];
        console.log(row);
        row.details.forEach(detail => {
          row.initDetails.forEach(initDetail => {
            if (detail.purchaseOrderId === initDetail.purchaseOrderId && detail.poDetailRowNo === initDetail.poDetailRowNo) {
              initDetail.isDisabled = true;
            }
          });
        });
        this.tableData = JSON.parse(JSON.stringify(row.initDetails));
        this.index = index;
      },
      select(selection) {
        this.tableData = [];
        this.dialogVisible = false;
        this.$emit("select", selection, this.index);
      },
      selectRow(row) {
        this.tableData = [];
        this.dialogVisible = false;
        this.$emit("select", row, this.index);
      },
    },
  };
</script>